import React, { useEffect } from 'react';
import { DataManager } from '../../../core/data-manager';


export default function IC_customer_offices({ data, entity, setDataKeyValue }) {

    useEffect(() => {
        if (data.idTypeOffice === "") {
            getTypeOffice()
        }
    }, [data]);

    async function getTypeOffice() {
        var constraints = [
            { fieldName: "defaultType", type: "value", value: 1 }
        ]
        var sorting = { 'field': 'id', 'order': 'desc' }
        var res = await DataManager.searchItems('type_office', 1, 100, sorting, '', [], constraints);
        if (res.success === 1) {
            setDataKeyValue('idTypeOffice', res.body[0])
        }
    }

    return (
        <></>
    )
};
